import { defineStore } from 'pinia';
import { ref } from 'vue';
import { supabase } from '@/lib/supabaseClient';

interface User {
  id: string;
  email: string;
  organization_id: string;
  // Add other user properties as needed
}

interface OrganizationSettings {
  ecommerce: boolean;
  realestate: boolean;
}

export const useUserStore = defineStore('user', () => {
  const user = ref<User | null>(null);
  const organizationSettings = ref<OrganizationSettings>({
    ecommerce: true,
    realestate: true
  });
  const isLoadingSettings = ref(false);
  
  const setUser = (userData: User | null) => {
    user.value = userData;
  };

  const fetchOrganizationSettings = async () => {
    if (!user.value?.organization_id) return;
    
    try {
      isLoadingSettings.value = true;
      
      const { data, error } = await supabase
        .from('organizations')
        .select('ecommerce, realestate')
        .eq('id', user.value.organization_id)
        .single();
        
      if (error) {
        console.error('Error fetching organization settings:', error);
        return;
      }
      
      if (data) {
        organizationSettings.value = {
          ecommerce: data.ecommerce === true,
          realestate: data.realestate === true
        };
      }
    } catch (err) {
      console.error('Failed to fetch organization settings:', err);
    } finally {
      isLoadingSettings.value = false;
    }
  };

  return {
    user,
    organizationSettings,
    isLoadingSettings,
    setUser,
    fetchOrganizationSettings
  };
}); 